var _dec, _dec2, _dec3, _dec4, _class, _class2, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { "BeanInfo" as __z_BeanInfo } from "zova";
import { BeanBase, Use } from 'zova';
import { Tool } from 'zova-module-a-bean';
import { SysIcon } from './sys.icon.js';
export let ToolIcon = (_dec = Tool(), _dec2 = __z_BeanInfo({
  module: "a-icon"
}), _dec3 = Use(), _dec4 = Reflect.metadata("design:type", typeof SysIcon === "undefined" ? Object : SysIcon), _dec(_class = _dec2(_class = (_class2 = class ToolIcon extends BeanBase {
  constructor(...args) {
    super(...args);
    this._iconSSR = {};
    _initializerDefineProperty(this, "$$sysIcon", _descriptor, this);
  }
  async __init__() {
    if (process.env.SERVER) {
      this.ctx.meta.$ssr.context.onRendered(err => {
        if (err) return;
        this._onRendered();
      });
    }
  }
  async parseIconInfo(iconName) {
    const iconInfo = await this.$$sysIcon.parseIconInfo(iconName);
    if (!iconInfo) return iconInfo;
    this._injectIconSSR(iconInfo.meta);
    return iconInfo;
  }
  _onRendered() {
    this.ctx.meta.$ssr.context._meta.bodyTags += this._renderSSRContainer();
  }
  _renderSSRContainer() {
    const contentModules = this._renderSSRModules();
    return `<div id="zova-svg-container" style="position: absolute; width: 0px; height: 0px; display: none;">${contentModules}</div>`;
  }
  _renderSSRModules() {
    return Object.keys(this._iconSSR).map(moduleName => {
      const moduleId = `zova-svg-module-${moduleName}`;
      const contentGroups = this._renderSSRGroups(this._iconSSR[moduleName], moduleName);
      return `<div id="${moduleId}">${contentGroups}</div>`;
    }).join('');
  }
  _renderSSRGroups(iconSSRGroups, moduleName) {
    return Object.keys(iconSSRGroups).map(groupName => {
      const groupId = `zova-svg-group-${moduleName}-${groupName}`;
      const contentIcons = this._renderSSRIcons(iconSSRGroups[groupName]);
      return `<svg id="${groupId}" xmlns="http://www.w3.org/2000/svg" xmlns:link="http://www.w3.org/1999/xlink">${contentIcons}</svg>`;
    }).join('');
  }
  _renderSSRIcons(iconSSRIcons) {
    return Object.keys(iconSSRIcons).map(symbolId => {
      return iconSSRIcons[symbolId];
    }).join('');
  }
  _injectIconSSR(meta) {
    if (process.env.CLIENT) return;
    const iconModule = this.$$sysIcon.getIconModule(meta.module);
    const iconGroup = iconModule[meta.group];
    if (!this._iconSSR[meta.module]) this._iconSSR[meta.module] = {};
    if (!this._iconSSR[meta.module][meta.group]) this._iconSSR[meta.module][meta.group] = {};
    this._iconSSR[meta.module][meta.group][meta.symbolId] = this.$$sysIcon.extractIconContent(iconGroup.svg, meta.symbolId);
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "$$sysIcon", [_dec3, _dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2)) || _class) || _class);